import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { Block } from 'slate';
export default function getInContinuousBlock(editor, node, path) {
  return Block.isBlockList(node.nodes) ? node.getIn(['nodes', 0].concat(_toConsumableArray(path))) : node.getIn(path);
}